module.exports = __webpack_public_path__ + "img/green-counter-bm.8c23c05b.png";